import * as React from 'react';
import {
  Controller, SubmitHandler, useFormContext,
} from 'react-hook-form';
import { Grid } from '@mui/material';
import {
  ErrorMessage,
  Label,
  PrimaryLiteButton,
  PrimaryLoadingButton,
  PrimaryTextField,
} from 'components';

import { ISkillModalForm } from '../../../../../interface';

interface SkillModalFormProps {
  onSubmit: SubmitHandler<any>;
  closeModal: () => void;
  index: number;
}

const OnboardSkillModalForm = ({ onSubmit, closeModal, index }: SkillModalFormProps) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useFormContext<ISkillModalForm>();
  const handleForm = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    handleSubmit(onSubmit)();
  };

  return (
    <form onSubmit={handleForm}>
      <h3 className="form-item">Add new skill</h3>
      <div className="form-item">
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Label>
              <i>
                Skill #
                {index}
              </i>
            </Label>
          </Grid>
        </Grid>
        <Controller
          name="name"
          control={control}
          render={({ field }) => <PrimaryTextField {...field} label="Skill name" />}
        />
      </div>
      <ErrorMessage>{errors?.name?.message}</ErrorMessage>
      <Grid container spacing={3}>
        <Grid item xs>
          <PrimaryLiteButton fullWidth onClick={closeModal}>
            Cancel
          </PrimaryLiteButton>
        </Grid>
        <Grid item xs>
          <PrimaryLoadingButton fullWidth type="submit">
            Add
          </PrimaryLoadingButton>
        </Grid>
      </Grid>
    </form>
  );
};

export default OnboardSkillModalForm;
